import React from "react";

class InputColor extends React.Component {
  constructor(props) {
    super(props);
    this.state = { safariBrowser: false };
    this.fileInput = null;
    this.setFileInputRef = (element) => {
      this.fileInput = element;
    };
  }

  componentDidMount() {
    navigator.userAgent.indexOf("Safari") > -1 &&
      !(navigator.userAgent.indexOf("Chrome") > -1) &&
      this.setState((prevState) =>
        Object.assign({}, prevState, {
          safariBrowser: true,
        })
      );
  }

  render() {
    const {
      inputName,
      inputNameColor = "",
      value,
      onChange = () => {},
      mobile = false,
      onlyRead = false,
      customClassNames = "",
    } = this.props;

    return (
      <div
        style={{
          position: "relative",
        }}
        className="input-color"
      >
        {onlyRead ? (
          <span className={customClassNames}>{value}</span>
        ) : (
          <input
            type="text"
            name={inputName}
            className={`${customClassNames} text-input`}
            onChange={onChange}
            value={value}
            placeholder="#000000"
            sz="large"
          />
        )}
        {(!this.state.safariBrowser || !mobile) && (
          <label
            htmlFor={inputNameColor}
            className="color-showcase"
            onClick={() => {
              if (this.fileInput && !onlyRead) this.fileInput.click();
            }}
            style={{
              background: value && value.length ? value : "#8867C1",
            }}
          >
            <div className="appcolor-pencil-wrapper">
              <img alt="pencil" src="/img/new-icons/edit-pencil.svg" />
            </div>
          </label>
        )}
        <input
          ref={this.setFileInputRef}
          type="color"
          id={`id-${inputNameColor}`}
          name={inputNameColor}
          onChange={onChange}
          style={
            this.state.safariBrowser && mobile
              ? {
                  border: "none",
                  borderRadius: "100%",
                  position: "absolute",
                  right: "7px",
                  width: "3.2rem",
                  height: "3.2rem",
                  padding: ".8rem",
                  top: "calc(50% - 1.6rem)",
                }
              : {
                  visibility: "hidden",
                  width: 0,
                  height: 0,
                  padding: 0,
                  margin: 0,
                }
          }
          value={value && value.length ? value : "#8867C1"}
        />
      </div>
    );
  }
}

export default InputColor;
